import React, { useState, useEffect } from "react";
import { Link, Element, Events, animateScroll as scroll } from "react-scroll";
import "./App.css";
import AboutMe from "./About/About";
import Portfolio from "./Porfilo/Portfolio";
import SocialMedia from "./Contact/SocialMedia";
import PortfolioImage from "./Porfilo/PortfolioImage";
import image1 from "./images/computer-3174729_1920.jpg";
import image2 from "./images/image4.jpg";
import image3 from "./images/office-620817_1920.jpg";
import image4 from "./images/desk-593327_1920 (1).jpg";
import image5 from "./images/man-593333_1920.jpg";
import image6 from "./images/web-design-2038872_1920.jpg";

const App = () => {
  const description =
    "I am a dedicated web developer with a passion for creating seamless and visually appealing online experiences. Armed with a strong foundation in HTML, CSS, talwaind, React, NextJs, NodeJS, PHP, and Laravel. I bring ideas to life through my coding skills. Having collaborated on diverse web projects, I am adept at crafting responsive and user-friendly websites. My journey in web development has equipped me with the ability to navigate complex challenges and deliver solutions that marry functionality with aesthetics. Always eager to stay at the forefront of technology trends, I am committed to continuous learning and innovation in the ever-evolving field of web development.";
  const [currentImage, setCurrentImage] = useState(0);
  const images = [image1, image2, image3, image4, image5, image6];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 15000); // Change the time (in milliseconds) for image rotation

    return () => clearInterval(interval);
  }, [images.length]);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  const handleArrowClick = (direction) => {
    if (direction === "prev") {
      setCurrentImage(
        (prevImage) => (prevImage - 1 + images.length) % images.length
      );
    } else {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }
  };

  return (
    <div className="app">
      <nav>
        <ul>
          <li>
            <Link className="link" to="home" smooth={true} duration={500}>
              Home
            </Link>
          </li>
          <li>
            <Link className="link" to="about" smooth={true} duration={500}>
              About
            </Link>
          </li>
          <li>
            <Link className="link" to="portfolio" smooth={true} duration={500}>
              Portfolio
            </Link>
          </li>
          <li>
            <Link className="link" to="contact" smooth={true} duration={500}>
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      <div
        className="home"
        style={{ backgroundImage: `url(${images[currentImage]})` }}
      >
        <PortfolioImage
          imageUrl="image2.jpg"
          title={"Hassanullah Shahbaz"}
          description={description}
        />
      </div>

      <Element name="about" className="section">
        <AboutMe />
      </Element>

      <Element name="portfolio" className="section">
        <Portfolio />
      </Element>

      <Element name="contact" className="section">
        <h2>Contact Me</h2>
        <SocialMedia />
      </Element>
    </div>
  );
};

export default App;
